/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Wang Chao
 * @date  2021/5/12 16:23
 * @des  尺寸相关方法封装
 */

import {isMobile} from './platform'
import {remove} from './arrayutil'

// const $log = console.log

/**
 * 获取页面宽度
 */
export function getPageWidth () {
  return document.body.clientWidth
}

/**
 * 获取页面高度
 */
export function getPageHeight () {
  return document.body.clientHeight
}

/************************窗口变化监听start************************************/

let pageResizeListeners = []
let onResizeCallback = null

/**
 * 监听窗口变化参数回传
 * @param listener func(pageWidth,pageHeight,isMobile)
 */
export function addPageResizeListener (listener) {
  if (listener) {
    pageResizeListeners.push(listener)
    initOnResizeCallbackIfNeed()
    //首次注册就默认响应一次回调,方便页面处理
    let pageWidth = getPageWidth()
    let pageHeight = getPageHeight()
    let isMobileEnv = isMobile(pageWidth)
    listener(pageWidth, pageHeight, isMobileEnv)
  }
}

/**
 * 移除窗口变化监听
 * @param listener
 */
export function removePageResizeListener (listener) {
  if (listener) {
    remove(pageResizeListeners, listener)
  }
}

/**
 * 初始化窗口变化监听
 */
function initOnResizeCallbackIfNeed () {
  if (onResizeCallback === null) {
    onResizeCallback = function () {
      let pageWidth = getPageWidth()
      let pageHeight = getPageHeight()
      let isMobileEnv = isMobile(pageWidth)
      for (let i = 0; i < pageResizeListeners.length; ++i) {
        let listener = pageResizeListeners[i]
        if (listener) {
          listener(pageWidth, pageHeight, isMobileEnv)
        }
      }
    }
    window.onresize = onResizeCallback
  }
}

/**************************窗口变化监听end**********************************/



// WEBPACK FOOTER //
// ./src/base/util/size.js